import { render, staticRenderFns } from "./nav-bookmarks.vue?vue&type=template&id=08585a8a&scoped=true&"
import script from "./nav-bookmarks.vue?vue&type=script&lang=js&"
export * from "./nav-bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./nav-bookmarks.vue?vue&type=style&index=0&id=08585a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08585a8a",
  null
  
)

component.options.__file = "nav-bookmarks.vue"
export default component.exports